#import "../fragments/ctct-contact.graphql"

mutation AddEntityToConstantContact($input: ConstantContactAddEntityToListInput!) {
    constantContactAddEntityToList(input: $input) {
        entity {
            primaryCtctContact {
                ...CtCtContact
            }
            ctctContacts {
                ...CtCtContact
            }
        }
    }
}
